var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.29,
    height: 47.3,
    viewBox: "0 0 38.29 47.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONOS-15",
    transform: "translate(-7.05 -3.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_837",
    "data-name": "Trazado 837",
    d: "M19.176,32.712a1.129,1.129,0,0,1-.45-2.162l.732-.315a13.551,13.551,0,0,1,11.476.349,1.123,1.123,0,0,1-1.014,2,11.341,11.341,0,0,0-9.573-.293l-.732.315a1.024,1.024,0,0,1-.439.09Z",
    transform: "translate(1.388 3.258)",
    fill: "#6f2fd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_838",
    "data-name": "Trazado 838",
    d: "M41.962,3.31H10.429A3.388,3.388,0,0,0,7.05,6.689V47.231a3.388,3.388,0,0,0,3.379,3.379H41.962a3.388,3.388,0,0,0,3.379-3.379V6.689A3.388,3.388,0,0,0,41.962,3.31ZM10.429,5.562H15.5v4.493a1.134,1.134,0,0,1-1.137,1.137H9.865a1.067,1.067,0,0,0-.563.169V6.689A1.129,1.129,0,0,1,10.429,5.562ZM43.088,47.231a1.13,1.13,0,0,1-1.126,1.126H10.429A1.13,1.13,0,0,1,9.3,47.231V13.277a1.067,1.067,0,0,0,.563.169h4.493a3.393,3.393,0,0,0,3.39-3.39V5.562H41.962a1.129,1.129,0,0,1,1.126,1.126Z",
    transform: "translate(0 0)",
    fill: "#6f2fd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_839",
    "data-name": "Trazado 839",
    d: "M19.876,22.742l1.014-1.07a1.123,1.123,0,1,0-1.633-1.543l-.935.98-.935-.98a1.123,1.123,0,1,0-1.633,1.543l1.014,1.07-1.014,1.07a1.12,1.12,0,0,0,.822,1.892,1.135,1.135,0,0,0,.822-.349l.935-.98.935.98a1.116,1.116,0,0,0,.822.349,1.148,1.148,0,0,0,.777-.3,1.122,1.122,0,0,0,.045-1.588L19.9,22.742Z",
    transform: "translate(1.06 2.078)",
    fill: "#6f2fd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_840",
    "data-name": "Trazado 840",
    d: "M30.876,22.742l1.014-1.07a1.123,1.123,0,1,0-1.633-1.543l-.935.98-.935-.98a1.123,1.123,0,1,0-1.633,1.543l1.014,1.07-1.014,1.07a1.12,1.12,0,0,0,.822,1.892,1.135,1.135,0,0,0,.822-.349l.935-.98.935.98a1.116,1.116,0,0,0,.822.349,1.148,1.148,0,0,0,.777-.3,1.122,1.122,0,0,0,.045-1.588L30.9,22.742Z",
    transform: "translate(2.448 2.078)",
    fill: "#6f2fd3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.f864f415bd42e60836355eb318c0a084.svg";
export { ForwardRef as ReactComponent };